import clsx from 'clsx';
import React, {useRef, useState, useEffect} from 'react';
import { NumericFormat } from 'react-number-format';

import FieldWrapper from '../FieldWrapper/FieldWrapper';

const defaultMaskOptions = {
  thousandsGroupStyle: 'thousand',
  thousandSeparator: ',',
  fixedDecimalScale: false,
};

const NumericInputField = ({
  label = '',
  containerClassName = '',
  registration = {},
  maskOptions = {},
  required = false,
  isAiGenerated = false,
  isManualExpensePrefilled = false,
  // ref, // Destructure but do not pass, we take care of this via registration prop or consuming <Controller>
  ...otherProps
}) => {
  // const decimalScale = maskOptions.decimalScale ?? 0;

  const initialValueRef = useRef(otherProps.value);
  const [hasValueChanged, setHasValueChanged] = useState(false);


  useEffect(() => {
    if (initialValueRef.current !== otherProps.value) {
      setHasValueChanged(true);
    } else {
      setHasValueChanged(false);
    }
  }, [otherProps.value]);

  return (
    <FieldWrapper label={label} required={required} containerClassName={containerClassName}>
      <NumericFormat
        className={clsx(
          'tw-text-right',
          isAiGenerated && '!tw-bg-[rgba(240,232,250,1)]',
          isManualExpensePrefilled && otherProps?.value !== null && !hasValueChanged && '!tw-bg-cfo-blue-200'
        )}
        {...defaultMaskOptions}
        {...maskOptions}
        {...otherProps}
        {...registration}
      />
    </FieldWrapper>
  );
};

export default NumericInputField;
